module.exports = __webpack_public_path__ + "img/icons8-facebook-f-30.23f8bd02.svg";